/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Download_WebInputs */

const en_cad_download_web = /** @type {(inputs: Cad_Download_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web`)
};

/**
* | output |
* | --- |
* | "Web" |
*
* @param {Cad_Download_WebInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_download_web = /** @type {((inputs?: Cad_Download_WebInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Download_WebInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_download_web(inputs)
});
export { cad_download_web as "cad.download.web" }